/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FRD
 */
export interface FRD {
  /**
   *
   * @type {string}
   * @memberof FRD
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof FRD
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof FRD
   */
  readonly updated?: Date;
  /**
   * Alleen beschikbaar voor de eigenaar van de put.
   * @type {string}
   * @memberof FRD
   */
  internalId: string | null;
  /**
   *
   * @type {string}
   * @memberof FRD
   */
  broId: string;
  /**
   *
   * @type {object}
   * @memberof FRD
   */
  linkedGmns: object;
  /**
   *
   * @type {string}
   * @memberof FRD
   */
  deliveryAccountableParty: string | null;
  /**
   *
   * @type {string}
   * @memberof FRD
   */
  qualityRegime: string | null;
  /**
   *
   * @type {string}
   * @memberof FRD
   */
  determinationType: string | null;
  /**
   *
   * @type {string}
   * @memberof FRD
   */
  gmwBroId: string | null;
  /**
   *
   * @type {string}
   * @memberof FRD
   */
  tubeNumber: string | null;
  /**
   *
   * @type {Date}
   * @memberof FRD
   */
  researchFirstDate: Date | null;
  /**
   *
   * @type {Date}
   * @memberof FRD
   */
  researchLastDate: Date | null;
  /**
   *
   * @type {string}
   * @memberof FRD
   */
  monitoringTube: string | null;
  /**
   *
   * @type {string}
   * @memberof FRD
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the FRD interface.
 */
export function instanceOfFRD(value: object): value is FRD {
  if (
    (!("internalId" in (value as Record<string, any>)) &&
      !("internal_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["internalId"] === undefined &&
      (value as Record<string, any>)["internal_id"] === undefined)
  )
    return false;
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  if (
    (!("linkedGmns" in (value as Record<string, any>)) &&
      !("linked_gmns" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["linkedGmns"] === undefined &&
      (value as Record<string, any>)["linked_gmns"] === undefined)
  )
    return false;
  if (
    (!("deliveryAccountableParty" in (value as Record<string, any>)) &&
      !("delivery_accountable_party" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["deliveryAccountableParty"] === undefined &&
      (value as Record<string, any>)["delivery_accountable_party"] === undefined)
  )
    return false;
  if (
    (!("qualityRegime" in (value as Record<string, any>)) &&
      !("quality_regime" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["qualityRegime"] === undefined &&
      (value as Record<string, any>)["quality_regime"] === undefined)
  )
    return false;
  if (
    (!("determinationType" in (value as Record<string, any>)) &&
      !("determination_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["determinationType"] === undefined &&
      (value as Record<string, any>)["determination_type"] === undefined)
  )
    return false;
  if (
    (!("gmwBroId" in (value as Record<string, any>)) &&
      !("gmw_bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["gmwBroId"] === undefined &&
      (value as Record<string, any>)["gmw_bro_id"] === undefined)
  )
    return false;
  if (
    (!("tubeNumber" in (value as Record<string, any>)) &&
      !("tube_number" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["tubeNumber"] === undefined &&
      (value as Record<string, any>)["tube_number"] === undefined)
  )
    return false;
  if (
    (!("researchFirstDate" in (value as Record<string, any>)) &&
      !("research_first_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["researchFirstDate"] === undefined &&
      (value as Record<string, any>)["research_first_date"] === undefined)
  )
    return false;
  if (
    (!("researchLastDate" in (value as Record<string, any>)) &&
      !("research_last_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["researchLastDate"] === undefined &&
      (value as Record<string, any>)["research_last_date"] === undefined)
  )
    return false;
  if (
    (!("monitoringTube" in (value as Record<string, any>)) &&
      !("monitoring_tube" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["monitoringTube"] === undefined &&
      (value as Record<string, any>)["monitoring_tube"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function FRDFromJSON(json: any): FRD {
  return FRDFromJSONTyped(json, false);
}

export function FRDFromJSONTyped(json: any, ignoreDiscriminator: boolean): FRD {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    internalId: json["internal_id"],
    broId: json["bro_id"],
    linkedGmns: json["linked_gmns"],
    deliveryAccountableParty: json["delivery_accountable_party"],
    qualityRegime: json["quality_regime"],
    determinationType: json["determination_type"],
    gmwBroId: json["gmw_bro_id"],
    tubeNumber: json["tube_number"],
    researchFirstDate:
      json["research_first_date"] == null ? null : new Date(json["research_first_date"]),
    researchLastDate:
      json["research_last_date"] == null ? null : new Date(json["research_last_date"]),
    monitoringTube: json["monitoring_tube"],
    dataOwner: json["data_owner"],
  };
}

export function FRDToJSON(json: any): FRD {
  return FRDToJSONTyped(json, false);
}

export function FRDToJSONTyped(
  value?: Omit<FRD, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    internal_id: value["internalId"],
    bro_id: value["broId"],
    linked_gmns: value["linkedGmns"],
    delivery_accountable_party: value["deliveryAccountableParty"],
    quality_regime: value["qualityRegime"],
    determination_type: value["determinationType"],
    gmw_bro_id: value["gmwBroId"],
    tube_number: value["tubeNumber"],
    research_first_date:
      value["researchFirstDate"] == null
        ? value["researchFirstDate"]
        : value["researchFirstDate"].toISOString().substring(0, 10),
    research_last_date:
      value["researchLastDate"] == null
        ? value["researchLastDate"]
        : value["researchLastDate"].toISOString().substring(0, 10),
    monitoring_tube: value["monitoringTube"],
    data_owner: value["dataOwner"],
  };
}
